import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'

export type EditGroupSuccessModalProps = Readonly<{
  isOpen: boolean
  handleClose: () => void
}>

export function EditGroupSuccessModal({ isOpen, handleClose }: EditGroupSuccessModalProps) {
  const { t } = useTranslation()

  return (
    <Modal open={isOpen} onClose={handleClose} aria-labelledby="edit-group-success">
      <AcknowledgeModal
        result="positive"
        title={t('typography.groupUpdatedTitle')}
        buttonText={t('button.close')}
        handleClose={handleClose}
        buttonTestId="edit-group-success-modal-btn"
      >
        {t('typography.groupUpdatedDescription')}
      </AcknowledgeModal>
    </Modal>
  )
}
